import React from 'react'
import { SharedBetCard } from '@core/Areas/BetLoop/Components/Common/SharedBetCard'
import { SkeletonLoader } from '@core/Areas/BetLoop/Components/Common/SkeletonLoader'
import { EmptyMessage } from '@core/Areas/BetLoop/Components/Common/EmptyMessage'
import { useSharedBetsData } from '@core/Areas/BetLoop/hooks/useSharedBetsData'

export const PendingBets: React.FC<{
  profileId: string
  setPendingBetsCount(count: number | null): void
  isUsingScrollRestore: boolean
  incomingPostId?: number
}> = ({ profileId, incomingPostId, isUsingScrollRestore, setPendingBetsCount }) => {
  const { isLoading, data, isRefetching, LoadMoreButton } = useSharedBetsData({
    feedType: 'pending',
    accountId: profileId,
    sortOrder: 'sortDesc',
    sortFilter: 'ShareTime',
  })

  React.useEffect(() => {
    const pendingBetsCount = data?.pages.flat().length || 0
    setPendingBetsCount(pendingBetsCount)
  }, [data, setPendingBetsCount])

  const shouldDisplayPreviousData = isUsingScrollRestore && Boolean(data?.pages)
  if (!shouldDisplayPreviousData && (isLoading || isRefetching)) return <SkeletonLoader />

  const pendingBetsData = data?.pages.flat()

  if (!pendingBetsData || pendingBetsData.length === 0)
    return (
      <EmptyMessage
        messageType='bettable-tip'
        title='No Shared Bets'
        description='No bets shared at the moment, check back later or refresh the page'
      />
    )

  const pendingBets = incomingPostId
    ? pendingBetsData.filter(bet => bet.postId !== incomingPostId)
    : pendingBetsData

  return (
    <>
      {pendingBets.map(sharedBet => (
        <SharedBetCard
          key={`${sharedBet.postId}.${sharedBet.ownerAccountId}`}
          sharedBet={sharedBet}
        />
      ))}

      <LoadMoreButton />
    </>
  )
}
